/**
 * Canonical entity-ref pattern: `toolCallId:toolType:[[1-based-index]]`
 * Used by the markdown remark plugin (text-content citations), the
 * ask-user-question option lookup, and the web extension's overlay chat.
 * Single source of truth; import-free so the web extension can bundle it.
 *
 * Two forms exported:
 * - ENTITY_REF_REGEX_GLOBAL: `g` flag, used by remark `findAndReplace` to walk a string.
 * - ENTITY_REF_REGEX: no flags, used by `.exec()` for single-value lookup.
 *
 * Unanchored: tolerates leading/trailing text the LLM sometimes adds (e.g.
 * "🖥️ OS: call_…:[[1]]" or "call_…:[[1]] = Mobile Safari").
 */
export const ENTITY_REF_REGEX_GLOBAL = /([\w-]+):(\w+):\[\[(\d+)\]\]/g;
export const ENTITY_REF_REGEX = /([\w-]+):(\w+):\[\[(\d+)\]\]/;
